export enum ImageType {
  BASELINE = 'BASELINE',
  SNAPSHOT = 'SNAPSHOT'
}

export const VISUAL_TESTING_BREADCRUMB = 'Visual Testing';
